import React, { useState } from 'react';
import { Dropdown } from 'semantic';

import InspectObject from 'components/modals/InspectObject';
import { useTranslation } from 'react-i18next';
import { Confirm } from 'components';
import { request } from 'utils/api';

export default function BillingPlansActions({
  billingPlanName,
  item,
  writeAccess,
  onReload,
} = {}) {
  const { t } = useTranslation();

  function onDelete() {
    return request({
      method: 'DELETE',
      path: `/1/billing-plans/${item.id}`,
    });
  }

  return (
    <>
      <Confirm
        header={t(
          'deleteDialog.header',
          'Are you sure you want to delete {{name}}?',
          { name: billingPlanName }
        )}
        content={t(
          'deleteDialog.content',
          'All data will be permanently deleted'
        )}
        trigger={
          <Dropdown.Item
            icon="trash"
            disabled={!writeAccess}
            text={t('common.delete', 'Delete')}
          />
        }
        onConfirm={async () => {
          await onDelete(item);
          await onReload();
        }}
        customErrorMessage={t(
          'billingPlans.customErrorMsg',
          'Cannot delete account tier billing plans linked to accounts!'
        )}
      />

      <InspectObject
        name={t('common.billingPlan', 'Billing Plan')}
        data={item}
        trigger={
          <Dropdown.Item text={t('common.inspect', 'Inspect')} icon="code" />
        }
      />
    </>
  );
}
